import React, { useState } from 'react';

function ProjectTablePagination(props) {
  const { currentPage, totalRows, onPrevPage, onNextPage, rowsPerPage, rowsShown, loading, onPageChange } = props;
  const [pageInput, setPageInput] = useState('');

  const totalPages = totalRows > 0 ? Math.ceil(totalRows / rowsPerPage) : 0;
  const lastRow = Math.min(currentPage * rowsPerPage, totalRows);
  const firstRow = lastRow === 0 ? 0 : Math.max(lastRow - rowsPerPage + 1, 1);

  // Define a new variable to check if there are no rows
  const noRows = totalRows === 0;

  const handlePageInputChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === '' || /^\d+$/.test(value)) {
      setPageInput(value);
    }
  };

  const handlePageInputSubmit = (e) => {
    if (e.key === 'Enter' || e.type === 'blur') {
      const pageNumber = parseInt(pageInput);
      if (pageNumber >= 1 && pageNumber <= totalPages && pageNumber !== currentPage) {
        onPageChange && onPageChange(pageNumber);
      }
      setPageInput(''); // Clear input after submission
    }
  };

  const handlePageInputBlur = (e) => {
    handlePageInputSubmit(e);
  };

  return (
    <div className='ProjectPagination'>
      <div className="pagination-container">
        <div className='pagination-main'>
          <div className='pagination-controls pagination-left-control'>
            {/* Disable the button if currentPage is 1 or there are no rows */}
            <button onClick={onPrevPage} disabled={loading || currentPage === 1 || noRows}>
              {'<'}
            </button>
          </div>
          
          <div className="pagination-page-info">
            <span>Page </span>
            <input
              type="text"
              value={pageInput}
              placeholder={currentPage.toString()}
              onChange={handlePageInputChange}
              onKeyDown={handlePageInputSubmit}
              onBlur={handlePageInputBlur}
              disabled={loading || noRows}
              className="pagination-page-input"
              style={{
                width: '40px',
                height: '20px',
                border: '1px solid #3C96D4',
                borderRadius: '4px',
                textAlign: 'center',
                fontSize: '12px',
                margin: '0 5px',
                background: loading || noRows ? '#e0e0e0' : '#ffffff'
              }}
            />
            <span> of {totalPages}</span>
          </div>
          
          <div className='pagination-controls pagination-right-control'>
            {/* Disable the button if currentPage is the last page, or there are fewer rows shown than rows per page, or there are no rows */}
            <button onClick={onNextPage} disabled={loading || currentPage === totalPages || rowsShown < rowsPerPage || noRows}>
              {'>'}
            </button>
          </div>
        </div>

        <div className='pagination-info'>
          <span>{`Showing ${firstRow}-${lastRow} of ${totalRows} records`}</span>
        </div>
      </div>
    </div>
  );
}

export default ProjectTablePagination;
